// The video editor's shell strings (components/Editor), under t('editor.rve.shell.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  topBar: {
    unsavedChanges: 'في تعديلات لسه متحفظتش',
    savesToAccountHint: 'التعديلات بتتحفظ في حسابك وإنت شغال',
    savesAutomatically: 'بيتحفظ لوحده',
    justNow: 'دلوقتي',
    pendingHint: 'مقدرناش نوصل لحسابك، فالشغل ده متحفظ في المتصفح ده، وبنحاول تاني لوحدنا.',
    deviceHint: 'مقدرناش نوصل لحسابك لما الصفحة فتحت، فالتعديلات فاضلة في المتصفح ده. افتح الصفحة تاني عشان تتحفظ في حسابك.',
    savedOnDevice: 'اتحفظ على الجهاز ده {when}',
    savedToAccount: 'اتحفظ في حسابك',
    saved: 'اتحفظ',
    savedWhen: 'اتحفظ {when}',
    backToProject: 'ارجع للمشروع',
    projectName: 'اسم المشروع',
    rename: 'غيّر الاسم',
    undo: 'تراجع',
    redo: 'إعادة',
    videoFormat: 'مقاس الفيديو',
    format: 'المقاس',
    keyboardShortcuts: 'اختصارات الكيبورد',
    watermarkHint: 'التصدير في الباقة المجانية عليه علامة مائية صغيرة',
    removeWatermark: 'شيل العلامة المائية',
    exporting: 'بنجهّز الفيديو {progress}%',
    export: 'صدّر',
  },
  formats: {
    vertical: { label: 'طولي', hint: 'تيك توك، ريلز، شورتس' },
    square: { label: 'مربع', hint: 'بوستات الفيد' },
    portrait: { label: 'بورتريه', hint: 'إنستجرام، فيسبوك' },
    landscape: { label: 'عرضي', hint: 'يوتيوب، الويب' },
  },
  exportDialog: {
    title: 'صدّر الفيديو',
    description: 'ملف MP4 معمول من كل حاجة على التايم لاين.',
    format: 'المقاس',
    size: 'الأبعاد',
    length: 'المدة',
    ready: 'الفيديو بتاعك جاهز',
    download: 'نزّل',
    exportAgain: 'صدّر تاني',
    starting: 'بنبدأ…',
    rendering: 'بنجهّز الفيديو',
    keepEditing: 'تقدر تقفل ده وتكمّل تعديل: التصدير هيكمّل، والتعديلات اللي هتعملها دلوقتي مش هتبقى فيه.',
    failed: 'التصدير فشل.',
    tryAgain: 'جرّب تاني',
    watermark: 'التصدير في الباقة المجانية عليه علامة مائية صغيرة.',
    upgrade: 'رقّي باقتك',
    tooLong: 'التصدير أقصاه 15 دقيقة، والفيديو ده مدته {length}. قصّه من التايم لاين أو من الكلام، وبعدين صدّر.',
    addSomethingFirst: 'حط حاجة على التايم لاين الأول',
    exportVideo: 'صدّر الفيديو',
    earlierExports: 'تصديرات قبل كده',
  },
  shortcuts: {
    title: 'اختصارات الكيبورد',
    description: 'بتشتغل في أي حتة في المونتاج، إلا وإنت بتكتب في خانة.',
    playPause: 'شغّل / وقّف',
    frameStep: 'فريم لورا / لقدام',
    secondStep: 'ثانية لورا / لقدام',
    jumpEnds: 'روح للأول / للآخر',
    split: 'اقسم الطبقة المختارة عند المؤشر',
    delete: 'امسح الطبقة المختارة',
    duplicate: 'اعمل نسخة من الطبقة المختارة',
    undo: 'تراجع',
    redo: 'إعادة',
    saveNow: 'احفظ دلوقتي',
    export: 'صدّر',
    deselect: 'الغي الاختيار',
    showShortcuts: 'اعرض الاختصارات',
  },
  inspector: {
    kinds: {
      text: 'نص',
      video: 'فيديو',
      image: 'صورة',
      audio: 'صوت',
      captions: 'كابشن',
      sticker: 'ستيكر',
      progressBar: 'شريط التقدم',
    },
    noSettings: 'الطبقة دي مالهاش إعدادات.',
    format: 'المقاس',
    background: 'الخلفية',
    backgroundColor: 'خلفية {color}',
    customColour: 'لون تختاره',
    customBackground: 'اختار لون الخلفية',
    backgroundHint: 'بتبان في أي حتة مفيهاش طبقة.',
    safeZones: 'المناطق الآمنة',
    safeZonesHint: 'بتضلّل الأماكن اللي تيك توك وريلز وشورتس بيحطوا فيها الزراير والكلام بتاعهم، عشان مفيش حاجة مهمة تستخبى تحتها.',
    showSafeZones: 'اعرض المناطق الآمنة',
    summaryOne: 'طبقة واحدة · المدة {length}. اختار طبقة من الفيديو أو من التايم لاين عشان تعدّلها.',
    summaryMany: 'عدد الطبقات: {n} · المدة {length}. اختار طبقة من الفيديو أو من التايم لاين عشان تعدّلها.',
    duplicateLayer: 'اعمل نسخة من الطبقة',
    duplicate: 'نسخة',
    deleteLayer: 'امسح الطبقة',
    delete: 'امسح',
    thisVideo: 'الفيديو ده',
    hideProperties: 'اخفي الإعدادات',
    properties: 'الإعدادات',
  },
  library: {
    nav: 'المكتبة',
    hidePanel: 'اخفي اللوحة',
    transcript: { label: 'الكلام', title: 'الكلام' },
    captions: { label: 'كابشن', title: 'الكابشن' },
    text: { label: 'نص', title: 'النص' },
    uploads: { label: 'ملفاتك', title: 'الملفات اللي رفعتها' },
    stock: { label: 'فيديوهات', title: 'فيديوهات جاهزة' },
    images: { label: 'صور', title: 'الصور' },
    audio: { label: 'صوت', title: 'مزيكا وأصوات' },
    brand: { label: 'البراند', title: 'هوية البراند' },
    exports: { label: 'التصدير', title: 'اللي صدّرته' },
  },
  mobile: {
    nav: 'تعديل',
    transcript: 'الكلام',
    captions: 'كابشن',
    text: 'نص',
    format: 'المقاس',
    exports: 'التصدير',
  },
  brand: {
    logoUpdated: 'اللوجو اتحدّث',
    logoAdded: 'اللوجو اتحط',
    captionStyleSaved: 'ستايل الكابشن اتحفظ',
    captionsRestyled: 'الكابشن خد الستايل الجديد',
    logo: 'اللوجو',
    upload: 'ارفع',
    pngHint: "PNG أو JPEG أو WebP لحد 2 ميجا. أحسن حاجة PNG بخلفية شفافة.",
    corner: 'الركن',
    corners: {
      topLeft: 'فوق شمال',
      topRight: 'فوق يمين',
      bottomLeft: 'تحت شمال',
      bottomRight: 'تحت يمين',
    },
    size: 'الحجم',
    opacity: 'الشفافية',
    updateLogo: 'حدّث اللوجو على الفيديو ده',
    addLogo: 'حط اللوجو على الفيديو ده',
    captionStyle: 'ستايل الكابشن',
    savedStyle: 'محفوظ: كابشن {font}.',
    customFont: 'بستايلك',
    styleHint: 'ظبّط كابشن فيديو واحد على مزاجك، احفظه هنا، وادّي كل فيديوهاتك نفس الشكل.',
    saveCurrent: 'احفظ الحالي',
    applySaved: 'طبّق المحفوظ',
    accountHint: "هوية البراند تبع حسابك: نفس اللوجو وستايل الكابشن هنا، وفي محرر المقاطع، وعلى كل مقطع تصدّره.",
    replace: "غيّره",
    remove: "شيل اللوجو",
    failed: "معرفناش نحفظ. جرّب تاني.",
    tooBig: "الصورة دي أكبر من 2 ميجا.",
    notPicture: "دي مش صورة PNG أو JPEG أو WebP.",
  },
  editor: {
    restored: 'كمّلنا من مكان ما وقفت: رجّعنالك تعديلاتك اللي عملتها {ago}.',
    startOver: 'ابدأ من الأصل تاني',
    dismiss: 'اقفل',
    opening: 'بنفتح مشروعك…',
    properties: 'الإعدادات',
  },
  stage: {
    frameError: 'مقدرناش نرسم الفريم ده',
    layerFailed: 'في طبقة محمّلتش.',
    linkExpired: 'ممكن يكون لينك ملف انتهى: افتح المشروع تاني وهيجيب لينكات جديدة.',
    startWithVideo: 'ابدأ بفيديو',
    startHint: 'هات الفيديو بتاعك، وبعدين قصّه وحط عليه كابشن ونص على التايم لاين اللي تحت.',
    uploadVideo: 'ارفع فيديو',
    browseStock: 'دوّر في الفيديوهات الجاهزة',
    addTitle: 'حط عنوان',
    startHintPhone: 'هات الفيديو بتاعك، وبعدين قصّه وحط عليه كابشن ونص من التابات اللي تحت.',
  },
  timelineLabels: {
    text: 'نص',
    image: 'صورة',
    video: 'فيديو',
    audio: 'صوت',
    caption: 'كابشن',
    sticker: 'ستيكر',
    progressBar: 'شريط التقدم',
    shape: 'شكل',
    item: 'عنصر',
  },
  renders: {
    countOne: 'تصدير واحد',
    countMany: 'عدد التصديرات: {n}',
    none: 'لسه مفيش تصدير',
    refresh: 'حدّث',
    nothingYet: 'لسه مصدّرتش حاجة',
    keptHere: 'أي فيديو تصدّره من المونتاج بيتحفظ هنا، وتقدر تنزّله تاني في أي وقت.',
    exportThis: 'صدّر الفيديو ده',
    exporting: 'بنجهّز الفيديو',
    video: 'فيديو',
    failed: 'التصدير فشل',
    download: 'نزّل',
  },
  page: {
    opening: 'بنفتح مشروعك…',
    openFailed: 'مقدرناش نفتح المشروع ده.',
    clipFailed: 'مقدرناش نفتح المقطع ده',
    projectFailed: 'مقدرناش نفتح المشروع ده',
    goBack: 'ارجع',
    seoTitle: 'المونتاج - أداة مونتاج فيديو أونلاين احترافية',
    seoDescription:
      'اعمل مونتاج لفيديوهاتك بأداة مونتاج أونلاين قوية. حط كابشن وطبقات وأنيميشن وتأثيرات. مونتاج على التايم لاين ومعاينة لحظية. مناسبة جدًا لعمل محتوى يشد الناس على السوشيال ميديا.',
  },
};
